import React from 'react';
import './Loading.css';

function Loading() {
    return (
        <div className="loading" image="loading" />
    );
}

export default Loading;